import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _candidateTypeMap;

import { capitalize } from 'lodash';
import { CandidateType } from '../shared/generated';
export var candidateValidationStatusList = [{
  value: 'imported',
  label: 'Imported'
}, {
  value: 'not_started',
  label: 'Not started'
}, {
  value: 'invitation_created',
  label: 'Invitation created'
}, {
  value: 'dropout',
  label: 'Dropout'
}, {
  value: 'cancelled',
  label: 'Cancelled'
}, {
  value: 'in_progress',
  label: 'In progress'
}, {
  value: 'fail',
  label: 'Fail'
}, {
  value: 'success',
  label: 'Success'
}, {
  value: 'paye_contractor',
  label: 'Paye contractor'
}];
export var candidateTypeMap = (_candidateTypeMap = {}, _defineProperty(_candidateTypeMap, CandidateType.CANDIDATE, {
  value: CandidateType.CANDIDATE,
  label: capitalize(CandidateType.CANDIDATE)
}), _defineProperty(_candidateTypeMap, CandidateType.SUPPLIER, {
  value: CandidateType.SUPPLIER,
  label: capitalize(CandidateType.SUPPLIER)
}), _candidateTypeMap);
export var candidateTypeList = Object.values(candidateTypeMap);